<template>
  <div
    :id="`tabpanel-${tabId}`"
    role="tabpanel"
    :aria-labelledby="`tab-header-${tabId}`"
    :class="{ 's-tab-panel--active': activeTabId === tabId }"
    :hidden="activeTabId !== tabId"
    :aria-hidden="`${activeTabId !== tabId}`"
    :data-cy="`tab-panel-${tabId}`"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'STabPanel',
  props: {
    tabId: {
      type: String,
      default: '',
    },

    activeTabId: {
      type: String,
      default: '',
    },
  },
}
</script>

<!--
NOTE:
Use this together with STabHeader.vue, in order to create an accessible tab component.
Dont use this component as a standalone!

`tabId` and `activeTabId` should be the same value as the corrisponding `tab.id` in the `tabs` array in STabHeader.vue

TODO:
move this small documentation to a markdown file, when storybook is ready
-->
